import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";

export const findHojaDeCargo = createAsyncThunk(
  "supervisorRequiredDocuments/findHojaDeCargo",
  async (id: any, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.hojasDeCargoURL}ProductsHojaCargo?hojaCargo=${id}`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
